import type { MutableRefObject } from 'react';

type MapViewportProps = {
  mapViewElementRef: MutableRefObject<HTMLDivElement | null>;
  isFullHeight: boolean;
};

export function MapViewport({
  mapViewElementRef,
  isFullHeight,
}: MapViewportProps) {
  return (
    <div
      className="flex-grow-1"
      style={{
        minWidth: 0,
        border: '1px solid #2c2c2c',
        borderRadius: '12px',
        overflow: 'hidden',
      }}
    >
      <div
        ref={mapViewElementRef}
        className={isFullHeight ? 'map-full-height' : 'map'}
        style={{ width: '100%' }}
      />
    </div>
  );
}
